import React, { useEffect, useState } from 'react';
import { useI18n } from '../../i18n/LanguageContext';
import { LANGS, Lang } from '../../types';

/** Fixed brand logo (master vector artwork) — colour version for the light header. */
const LOGO = `${process.env.PUBLIC_URL}/rts-logo.svg`;

const LANG_NAMES: Record<Lang, string> = { de: 'Deutsch', en: 'English', it: 'Italiano' };

const NAV: { href: string; key: string; cta?: boolean }[] = [
  { href: '#about', key: 'nav.about' },
  { href: '#products', key: 'nav.products' },
  { href: '#services', key: 'nav.services' },
  { href: '#customers', key: 'nav.customers' },
  { href: '#quality', key: 'nav.quality' },
  { href: '#contact', key: 'nav.contact', cta: true },
];

function scrollToHash(href: string, e: React.MouseEvent) {
  const id = href.replace('#', '');
  const el = document.getElementById(id);
  if (el) {
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

const Header: React.FC = () => {
  const { t, lang, setLang } = useI18n();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <header id="header" className={scrolled ? 'scrolled' : ''}>
        <nav>
          <a href="#hero" className="logo" onClick={(e) => scrollToHash('#hero', e)}>
            <img src={LOGO} alt="RTS S.p.A." height={80} decoding="async" style={{ height: 80, width: 'auto' }} />
          </a>
          <ul className="nav-links">
            {NAV.map((n) => (
              <li key={n.href}>
                <a
                  href={n.href}
                  className={n.cta ? 'nav-cta' : undefined}
                  onClick={(e) => scrollToHash(n.href, e)}
                >
                  {t(n.key)}
                </a>
              </li>
            ))}
          </ul>
          <div className="lang-switcher" role="group" aria-label="Language / Sprache / Lingua">
            {LANGS.map((l: Lang) => (
              <button
                key={l}
                className={`lang-btn${l === lang ? ' active' : ''}`}
                onClick={() => setLang(l)}
                type="button"
                aria-label={LANG_NAMES[l]}
                aria-pressed={l === lang}
              >
                {l.toUpperCase()}
              </button>
            ))}
          </div>
          <button className="hamburger" type="button" aria-label="Menu" onClick={() => setMenuOpen((o) => !o)}>
            <span /><span /><span />
          </button>
        </nav>
      </header>

      <div className={`mobile-menu${menuOpen ? ' open' : ''}`} id="mobileMenu">
        {NAV.map((n) => (
          <a
            key={n.href}
            href={n.href}
            onClick={(e) => { setMenuOpen(false); scrollToHash(n.href, e); }}
          >
            {t(n.key)}
          </a>
        ))}
      </div>
    </>
  );
};

export default Header;
